// extracted by mini-css-extract-plugin
var _1 = "EmbedLoginView-module__container--hkidG";
export { _1 as "container" }
